import Index from './index.vue'

export default {
  name: 'interviewManagement',
  path: '/v-admin/interview-management',
  component: Index,
  meta: {
    isInclude: true,
    titleI18nKey: 'admin.application.candidate.title.interviewManagement'
  }
}
